/**
 * @file h5 sessionStorage / localStorage 方法拓展
 * @author
 * @description 无痕浏览模式问题参考:https://my.oschina.net/jamesview/blog/2252926
 *
 *
 * @method isStorageSupported 检测用户浏览器 是否支持 sessionStorage/localStorage
 * @returns {boolean} 是否支持存储
 *
 * @constructor SessionStorage 构造函数
 * @description 通过 var sessionA = new sessionStorage() 来调用内部的 sessionA.setItem 方法,
 * 该方法已做 try 包裹, 不会报错
 *
 * @constructor LocalStorage 构造函数
 * @description 通过 var localA = new localStorage() 来调用内部的 localA.setItem 方法,
 * 该方法已做 try 包裹, 不会报错
 */

/**
 * 判断用户端是否支持 storage 存储(可以用于判断是否开启了无痕浏览)
 * @returns {boolean}
 */
function isStorageSupported() {
  const testKey = 'test'
  try {
    const storage = window.sessionStorage
    storage.setItem(testKey, 'testValue')
    storage.removeItem(testKey)
    return true
  } catch (error) {
    return false
  }
}

/**
 * 构造函数
 * try 包裹的 SessionStorage 的方法
 */
class SessionStorage {
  setItem(key: any, value: any) {
    try {
      window.sessionStorage.setItem(key, value)
    } catch (e) {
      console.log(e)
    }
  }

  getItem(key: any) {
    try {
      return window.sessionStorage.getItem(key)
    } catch (e) {
      console.log(e)
    }
  }

  removeItem(key: any) {
    try {
      window.sessionStorage.removeItem(key)
    } catch (e) {
      console.log(e)
    }
  }
}

/**
 * 构造函数
 * try 包裹的 LocalStorage 的方法
 */
class LocalStorage {
  setItem(key: any, value: any) {
    try {
      window.localStorage.setItem(key, value)
    } catch (e) {
      console.log(e)
    }
  }

  getItem(key: any) {
    try {
      return window.localStorage.getItem(key)
    } catch (e) {
      console.log(e)
    }
  }

  removeItem(key: any) {
    try {
      window.localStorage.removeItem(key)
    } catch (e) {
      console.log(e)
    }
  }
}

export default {
  localStorage: new LocalStorage(),
  sessionStorage: new SessionStorage(),
  isStorageSupported,
}
